// Invalid XML control characters, plus a lone (unpaired) high or low surrogate. A valid surrogate
// pair (a real emoji or other astral character) must survive — only an unpaired half is illegal.
const INVALID_XML_CONTROL_CHARACTERS = /[\u0000-\u0008\u000B\u000C\u000E-\u001F￾￿]/g;
const LONE_HIGH_SURROGATE = /[\uD800-\uDBFF](?![\uDC00-\uDFFF])/g;
const LONE_LOW_SURROGATE = /(?<![\uD800-\uDBFF])[\uDC00-\uDFFF]/g;

export function escapeXml(value: string) {
  return value
    .replace(INVALID_XML_CONTROL_CHARACTERS, "")
    .replace(LONE_HIGH_SURROGATE, "")
    .replace(LONE_LOW_SURROGATE, "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&apos;");
}

export function columnNumberToName(value: number) {
  let column = "";
  let current = value;

  while (current > 0) {
    const remainder = (current - 1) % 26;
    column = String.fromCharCode(65 + remainder) + column;
    current = Math.floor((current - 1) / 26);
  }

  return column;
}
